// src/utils/linkUrlValidation.js

/**
 * Only requires the input to start with "http://" or "https://"
 * If input starts with http:// or https:// (case-insensitive) -> { valid: true, protocol }
 * Otherwise -> { valid: false, error: 'URL must include http:// or https://' }
 */
export function validateUrlProtocol(rawInput) {
    if (typeof rawInput !== 'string') {
        return { valid: false, error: 'URL is invalid' };
    }

    const schemeMatch = rawInput.match(/^(https?):\/\//i);
    if (!schemeMatch) {
        return { valid: false, error: 'URL must include http:// or https://' };
    }

    return {
        valid: true,
        error: null,
    };
}

export default validateUrlProtocol;
